import { styled } from '@mui/material';

export const StyledTabsContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});
